// src/lib/qtyStepper.js
// THE SHARED QUANTITY STEPPER'S RULES (#746, #760) - Session 79.22b.6.3.1.
// Pure, so src/components/QtyStepper.js and its test agree on every press.
//
// Gate 746, F3 ("− and +", "The number box") and F5 ("A new shared quantity
// stepper"), with Colby's 746 D31 addition (every quantity box takes a typed
// number as well as − and +) and his ruling at 79.22b.6.3.1 (R1 D5, #760's
// amendment (3)): A DECIMAL POINT IS REFUSED, NOT DROPPED. The gate's words were
// "anything else typed is dropped as it is typed"; dropped, the point in a typed
// 2.5 vanishes and the digits stay - 25, ten times what was meant, on a receive.
// So a point or a comma leaves the number as it was and the box says
// "Whole numbers only."; letters, spaces and dashes are still dropped as typed.
//
// Values are strings of digits, '' when the box is empty, because an empty box
// is a real state (the record box starts empty, F2) that a number cannot hold.

export const STEPPER_MAX = 9999;
export const WHOLE_NUMBERS_ONLY = 'Whole numbers only.';

// − and +: a step of 1. On an empty box + gives 1 (or the minimum, if that is
// higher) and − does nothing; at the minimum or the maximum the press keeps the
// number. Never disabled (F3) - a press at a limit simply changes nothing.
export function stepValue(value, delta, { min = 0, max = STEPPER_MAX } = {}) {
  const s = String(value ?? '');
  if (s === '') return delta > 0 ? String(Math.min(Math.max(min, 1), max)) : '';
  const n = parseInt(s, 10);
  if (!Number.isFinite(n)) return s;
  const next = n + delta;
  if (next < min || next > max) return String(n);
  return String(next);
}

// What the box holds after a person types `raw` over `prev`. Answers
// { value, refused }: refused is the sentence to show when the typing was a
// decimal point or comma, and then the value is `prev`, unchanged.
export function typedValue(prev, raw) {
  const s = String(raw ?? '');
  if (/[.,]/.test(s)) return { value: String(prev ?? ''), refused: WHOLE_NUMBERS_ONLY };
  const digits = s.replace(/\D+/g, '');
  // Leading zeros go ("007" is 7) but a lone 0 stays a 0.
  const value = digits === '' ? '' : String(parseInt(digits, 10));
  return { value, refused: null };
}

// The number the box shows, or null when it is empty.
export function stepperNumber(value) {
  const s = String(value ?? '');
  if (!/^\d+$/.test(s)) return null;
  return parseInt(s, 10);
}
